"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VectorLayer = void 0;
var ste_simple_events_1 = require("ste-simple-events");
var Vector_1 = require("ol/layer/Vector");
var VectorLayer = /** @class */ (function () {
    function VectorLayer(_layerSubType, group, _minZoom, _maxZoom, layerName, style, _queryable) {
        var _this = this;
        if (_minZoom === void 0) { _minZoom = 0; }
        if (_maxZoom === void 0) { _maxZoom = 19; }
        this._layerSubType = _layerSubType;
        this.group = group;
        this._minZoom = _minZoom;
        this._maxZoom = _maxZoom;
        this.layerName = layerName;
        this.style = style;
        this._queryable = _queryable;
        //event - LayerLoading
        this._onLayerLoading = new ste_simple_events_1.SimpleEventDispatcher();
        //event - LayerLoaded
        this._onLayerLoaded = new ste_simple_events_1.SimpleEventDispatcher();
        this.setSource = function (vectorLayerSource) {
            _this._vectorLayerSource = vectorLayerSource;
            //merge opts using the new spread operator
            //let options: olx.layer.VectorOptions = { ...opts, ...this._layerOpts };
            var options = {
                source: vectorLayerSource.source,
                style: _this.style
            };
            _this._vectorLayer = new Vector_1.default(options);
            _this._vectorLayer.set("queryable", _this._queryable);
            _this._vectorLayer.set("layerGroup", _this.group);
            _this.addSourceHandlers(vectorLayerSource);
        };
        this.addSourceHandlers = function (vectorLayerSource) {
            vectorLayerSource.onSourceLoading.subscribe(_this.onSourceLoading);
            vectorLayerSource.onSourceLoaded.subscribe(_this.onSourceLoaded);
        };
        this.onSourceLoading = function (args) {
            _this._onLayerLoading.dispatch(args);
        };
        this.onSourceLoaded = function (args) {
            _this._maxFeatureCountReached = args.maxFeatureCountReached;
            _this._featureCount = args.featureCount;
            _this._onLayerLoaded.dispatch(args);
        };
        this.setInitialVisibility = function (mapZoom, store, visibleOnLoad) {
            _this._visible = (mapZoom >= _this._minZoom && mapZoom <= _this._maxZoom);
            if (_this._visible === true) {
                //layer is within zoom levels
                if (visibleOnLoad === true) {
                    _this._visible = true;
                    store.onLayerVisibiltyChanged(_this.group.ref, true);
                }
                else {
                    _this._visible = store.isLayerVisibile(_this.group.ref, _this.group.visibleOnFirstLoad);
                }
            }
            _this.setLayerVisibility(_this._visible);
        };
        this.setVisibility = function (mapZoom, store) {
            _this._visible = (mapZoom >= _this._minZoom && mapZoom <= _this._maxZoom);
            if (_this._visible === true) {
                //layer is within zoom levels
                _this._visible = store.isLayerVisibile(_this.group.ref, _this.group.visibleOnFirstLoad);
            }
            _this.setLayerVisibility(_this._visible);
        };
        this.clearSource = function () {
            _this._vectorLayerSource.clear();
        };
        this.setLayerVisibility = function (visible) {
            if (_this._vectorLayer) {
                _this._vectorLayer.setVisible(visible);
            }
        };
        this.loadedBounds = null;
        this._maxFeatureCountReached = false;
        this._featureCount = 0;
    }
    Object.defineProperty(VectorLayer.prototype, "onLayerLoading", {
        get: function () {
            return this._onLayerLoading.asEvent();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VectorLayer.prototype, "onLayerLoaded", {
        get: function () {
            return this._onLayerLoaded.asEvent();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VectorLayer.prototype, "visible", {
        get: function () {
            return this._visible;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VectorLayer.prototype, "layerSubType", {
        get: function () {
            return this._layerSubType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VectorLayer.prototype, "minZoom", {
        get: function () {
            return this._minZoom;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VectorLayer.prototype, "maxZoom", {
        get: function () {
            return this._maxZoom;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VectorLayer.prototype, "olVectorLayer", {
        get: function () {
            return this._vectorLayer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VectorLayer.prototype, "source", {
        get: function () {
            return this._vectorLayerSource;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VectorLayer.prototype, "maxFeatureCountReached", {
        get: function () {
            return this._maxFeatureCountReached;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VectorLayer.prototype, "featureCount", {
        get: function () {
            return this._featureCount;
        },
        enumerable: false,
        configurable: true
    });
    return VectorLayer;
}());
exports.VectorLayer = VectorLayer;
//# sourceMappingURL=VectorLayer.js.map